import React, { useState, Fragment, useEffect } from 'react';
import { createPortal } from 'react-dom';
// External components
import { Row, Col } from 'react-simple-flex-grid';
// Components
import Loading from "../common/Loading/Loading.jsx";
// Helper
import { isNull } from '../lib/helpers.js';
// Styles
import './Benefits/benefitsFrame.css';
import CategoryMenu from './Benefits/CategoryMenu.jsx';
import Accordion from '../common/Accordion/Accordion.jsx';
import Dialog from '../common/Dialog/Dialog.jsx';
import IoButton from '../common/IoButton/IoButton.jsx';
import MobileMenu from './Benefits/MobileMenu.jsx';


function BenefitsFrame({
    namedstrings,
    frameInfo
}) {
    const { benefitDetails } = frameInfo;

    //parse product infos into a map with productId as key
    const benefits = new Map();
    benefitDetails.forEach((data) => {
        if ( data['frameData']) {
            data['frameData'].forEach((tileProduct) =>{
                if (tileProduct['productId']) {
                    benefits.set(tileProduct['productId'], tileProduct);
                }
            })
        }
    })
   
    const [index, setIndex] = useState(0);
    const [showDetailsDialog, setShowDetailsDialog]   = useState(false);
    const [showPunchoutDialog, setShowPunchoutDialog] = useState(false);
    const [productDetail, setProductDetail] = useState({productId: '', pDisplayName: '', displayName: '', longDescription: '', productLargeImgSrc: '', 
                                                        punchOutStyleId: 0, punchOutUrl: '', completePunchOutUrl: '', 
                                                        buttonLabel: '', popTitle: '', popBody: '', popBtn: '', popExtraUrlBtn: '', 
                                                        popContUrlBtn: '', punchoutAdditionalURL: '', punchoutContUrl: '', usePunchoutDialog: false, 
                                                        //info for tracking
                                                        punchoutCtaType: '', productTypeId: '0', productTypeName: '', primary_catId: '', primary_catName: '', 
                                                        eventTime: '', geographicName: '', geographicCountryShortCode: '',
                                                        }); //detail of the product being viewed

    const [adobeTrackingHomePageName, setAdobeTrackingHomePageName] = useState('category.index'); //default; will modify if DI is available
    const [isMobileApplied, setIsMobileApplied] = useState(false);

    const ADOBE_TRACKING_NAME_PDP = 'BenefitsPageLoad';
    const ADOBE_TRACKING_NAME_CTA = 'CTA Click';
    const ADOBE_TRACKING_PRODUCT_PAGE_NAME = 'product.index'; //on PDP diaglog open, we need to update pageName variable for Adobe Tracking

    function handleSectionClick(index = 1) { //for desktop menu
        // check in index exisits?
        setIndex(index);
        //track here for desktop
        adobeProductImpressionTrackingforBenefitsFrame(index, null);
        //setTilesHtml(frameInfo['benefitDetails'][index]['tilesHtml']);
    }

    const [openIndex, setOpenIndex] = useState(null); //for mobile menu

    function handleSectionTitleClick(newIndex) {
        if (newIndex != openIndex) {
            setOpenIndex(newIndex);
            window.scrollTo({top: 0});
            adobeProductImpressionTrackingforBenefitsFrame(null, newIndex);
        } else {
            setOpenIndex(null);
        }
    }

    function productTileClick (e, productId) {
        e.stopPropagation();
        e.preventDefault();
        let productDetail = benefits.get(productId);


        let productUrl = productDetail['productUrl'];
        switch(productDetail['punchOutStyleId']) {
            case '0':
                window.location.replace(productUrl);
                break;
            default:
                showProductDetailsDialog(productDetail);
        }
    }
    
    function showProductDetailsDialog (clickedProductDetail) {
        let updatedProductDetail = {};
        //clicked Product Detail contains all the info, so iterate to extract only the necessary info, based on the attributes in productDetail state
        Object.keys(productDetail).forEach(function(key) {
            updatedProductDetail[key] = (key in clickedProductDetail) ? clickedProductDetail[key] : '';
        })
        updatedProductDetail['usePunchoutDialog'] = clickedProductDetail['punchOutStyleId'] != '0' && clickedProductDetail['punchOutStyleId'] != '3';
        updatedProductDetail['completePunchOutUrl'] = clickedProductDetail['completePunchOutUrl'] ? clickedProductDetail['completePunchOutUrl'] : clickedProductDetail['punchOutUrl'];
        setProductDetail(updatedProductDetail);
        setShowDetailsDialog(true);

        //track 'Benefit Page Load' when we show PDP dialog
        adobeSatelliteSetPageName(ADOBE_TRACKING_PRODUCT_PAGE_NAME); //set di's pageName to 'product.index' when dialog opens
        let trackingData = getProductTrackingData(updatedProductDetail); //pass in product detail being viewed because universal variable hasn't updated yet
        adobeTrackingforBenefitsFrame(ADOBE_TRACKING_NAME_PDP, trackingData);
    }

    function onDetailsDialogClose () {
        setShowDetailsDialog(false);
        adobeSatelliteSetPageName(adobeTrackingHomePageName); //restore di's pageName to original when dialog is closed
    }

    function showProductPunchoutDialog () {
        setShowDetailsDialog(false);
        setShowPunchoutDialog(true);

        //track CTA Click when CTA is clicked on PDP
        let trackingData = getProductTrackingData();
        trackingData['ctaName'] = productDetail['buttonLabel'] + ' Initiated';
        trackingData['ctaType'] = productDetail['punchoutCtaType'];
        adobeTrackingforBenefitsFrame(ADOBE_TRACKING_NAME_CTA, trackingData);
    }
    
    function onPunchoutDialogClose () {
        setShowPunchoutDialog(false);
        setShowDetailsDialog(true);
    }

    function punchOutToLink (redirectUrl, clickedCTAText) {
        if (redirectUrl) {
            window.open(redirectUrl,'_blank');
        }

        //track CTA Click when CTA is clicked on punchout dialog
        let trackingData = getProductTrackingData();
        trackingData['ctaName'] = clickedCTAText + ' Completed';
        trackingData['ctaType'] = productDetail['punchoutCtaType'];
        trackingData['link']    = redirectUrl;
        adobeTrackingforBenefitsFrame(ADOBE_TRACKING_NAME_CTA, trackingData);
    }


    function adobeProductImpressionTrackingforBenefitsFrame(index, openIndex) {
        //based on the category being opened, get the list of product displayed and start the tracking
        let trackingIndex = (index === null) ? openIndex : index;
        if ((trackingIndex != null) && (trackingIndex in benefitDetails)) {
            adobeProductImpressionTracking(benefitDetails[trackingIndex]['frameData'])
        }
    }


    function adobeTrackingforBenefitsFrame (trackingType, trackingData = []) {
        if (trackingType == ADOBE_TRACKING_NAME_PDP) { //add page-wise di data for benefit PDP view
            let pageDi = (typeof di !== 'undefined') ? di : [];
            let pageData = {
                'accessCode'   : ('accessCode' in pageDi)    ? pageDi.accessCode    : '' ,
                'accessCodeId' : ('accessCodeId' in pageDi)  ? pageDi.accessCodeId  : '' ,
                'offerCategory': ('offerCategory' in pageDi) ? pageDi.offerCategory : '' ,
                'deviceType'   : ('deviceType' in pageDi)    ? pageDi.deviceType    : '' ,
                
                'country'  : ('country' in pageDi)   ? pageDi.country   : '' ,
                'region'   : ('region' in pageDi)    ? pageDi.region    : '' ,
                'language' : ('language' in pageDi)  ? pageDi.language  : '' ,
                'loginType': ('loginType' in pageDi) ? pageDi.loginType : '' ,
        
                'pageTitle':  document.title,
                'pageURL' : ('pageURL' in pageDi)  ? pageDi.pageURL  : window.location.href, 
                'pageType': ('pageType' in pageDi) ? pageDi.pageType : '' ,
                'pageName': ('pageName' in pageDi) ? pageDi.pageName : '' ,
                'siteName': ('siteName' in pageDi) ? pageDi.siteName : '' ,

                'event'   : ('event' in pageDi)    ? pageDi.siteName : '' ,
                'productItems': '', //don't pass productItems for now, because di's productItems currently are for tiles in the background
            };
            let combinedTrackingData = { ...pageData, ... trackingData};
            trackingData         = combinedTrackingData;
        }
        try {
            adobeSatelliteTracking(trackingType, trackingData);
        } catch(ex) { //we don't use function until page is fully loaded so shouldn't happen
            let message = 'adobeSatelliteTracking() failed: ' + ex.message;
        }
    }
    
    function getProductTrackingData (updatedProductDetail = false) { //gather the tracking data for the currently opened product; either passed in or gather from universal state variable
        let currentProduct = updatedProductDetail ? updatedProductDetail : productDetail;
        let trackingData = {'productId': currentProduct['productId'], 'offerName': currentProduct['pDisplayName'], 'offerCategory': currentProduct['primary_catName'], 
                            'merchantName': currentProduct['displayName'], 'offerType': currentProduct['productTypeId'].concat(' - ', currentProduct['productTypeName']),  
                            'contentCity': currentProduct['geographicName'].substring(0, currentProduct['geographicName'].indexOf(',')), 
                            'contentCountry': currentProduct['geographicCountryShortCode'],
                            'offerDate': currentProduct['eventTime'], 'experienceType': currentProduct['productTypeId'] == 30 ? 'Article' : 'Non-article'
                           };
        return trackingData;
    }


    useEffect(() => {
        if (typeof di !== 'undefined' && 'pageName' in di) {
            setAdobeTrackingHomePageName(di['pageName']);
        }

        // need to add addEventListener to render this on mobile nav
        // #top (mobile nav div) DOM element is not present with initial load on desktop
        // when shrinking resolution from desktop to mobile, #top becomes available
        // #benefit-mobile located in /m/layouts/_top
        if (g_enableMobileCategoryDropdown) {
            function resizePageMobile() {
                if (! isMobileApplied && window.innerWidth <= 768) {
                    setIsMobileApplied(true);
        
                    
                }
            }
        
            window.addEventListener('resize', resizePageMobile);
            resizePageMobile();
    
            return () => window.removeEventListener('resize', resizePageMobile);
        }
  
    }, []);

    return (
        <div className="benefits-frame-container">
            {g_enableMobileCategoryDropdown && isMobileApplied && createPortal(
                <MobileMenu frameInfo={frameInfo} productTileClick={productTileClick}/>,
                document.getElementById('benefit-mobile')
            )}
            <h2 className="text-center-xs text-center-sm">{namedstrings['myBenefits']}</h2>
            <Row className="benefits-frame desktop" gutter={40}>
                <Col xs={{ span: 0 }} sm={4} className="benefits-frame-sidebar-container">
                    <CategoryMenu sectionDetails={frameInfo['benefitDetails']}
                                  sectionClick={handleSectionClick}
                                  productTileClick={productTileClick}
                                  sidebar = {true}
                    />
                </Col>
                <Col xs={{ span: 0 }} sm={8} className="benefits-frame-content">
                    <Row gutter={30} className="product-tiles">
                    {             
                        benefitDetails[index]['tilesHtml'].map((data, tileIndex) => {
                            
                            return (
                                <Col xs={12} sm={4} key={data['productId']} 
                                    onClick={e => {productTileClick(e, data['productId']);}} >
                                    <div className="product-tile-container" dangerouslySetInnerHTML={{__html: data['html']}}/>
                                </Col>
                                
                            );
                        })
                    }
                    </Row>                    
                </Col>
            </Row>

            <Row className="benefits-frame mobile">
            {
                frameInfo['benefitDetails'].map((info, sectionIndex) => {
                    const title = info['typographyItems'][0]['textContent'];
                    return (
                        <>
                            <Accordion 
                                title={title} 
                                className="benefits-frame-accordian-container"
                                onClick={() => handleSectionTitleClick(sectionIndex)}
                                open = {sectionIndex == openIndex ? true : false}
                                openIcon={getStaticFile("/images/svg/orange-minus.svg")}
                            >
                                <div>
                                    {     
                                        benefitDetails[sectionIndex]['tilesHtml'].map((data, tileIndex) => {
                                            return (
                                                <Col xs={12} sm={{ span: 0 }} key={data['productId']} onClick={e => productTileClick(e, data['productId'])}>
                                                    <div dangerouslySetInnerHTML={{__html: data['html']}}/>
                                                </Col>
                                                
                                            );
                                        })
                                    }
                                </div>
                            </Accordion>
                            <hr />
                        </>
                    );
                })
            }
            </Row>
            
            <Dialog className='nopadding product-details-dialog' isOpen={showDetailsDialog} onClose={onDetailsDialogClose} directControl={true} wide={true}> 
                <Row className="product-dialog-container">
                    <Col className="side-image-column desktop" >
                        <div className="side-image-container desktop">
                            <img className="" src={productDetail['productLargeImgSrc']} />
                        </div>
                    </Col>
                    <Col className="product-detail-column" >
                        <div className="product-detail-container">
                            <div className="top-image-container mobile">
                                <img className="" src={productDetail['productLargeImgSrc']} />
                            </div>

                            <div className="header-container">
                                <div className="product-detail-header sg-f-dspl-m"> {productDetail['pDisplayName']} </div>
                                <div className="product-detail-subheader sg-f-ttl"> {namedstrings['theBenefit']} </div>
                            </div>

                            <div className="description-container sg-f-bdy" dangerouslySetInnerHTML= {{__html: productDetail['longDescription']}}></div>
                            
                            <div className="button-container">
                                {
                                    (productDetail['usePunchoutDialog']) && (
                                        <IoButton classOverride="product-primary-btn" buttonText={productDetail['buttonLabel']} onClick={() => showProductPunchoutDialog()} />
                                    )
                                
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
            </Dialog>

            {productDetail['usePunchoutDialog'] && (
                <Dialog className='nopadding product-punchout-dialog' isOpen={showPunchoutDialog} onClose={onPunchoutDialogClose} directControl={true} wide={true} hideCloseButton={true}> 
                    <div className = "punchout-dialog-container">
                        <div className="dialog_title sg-f-dspl-m"> {productDetail['popTitle']} </div>
                        <div className="body_container sg-f-bdy" dangerouslySetInnerHTML={{__html: productDetail['popBody']}}></div>
                        <div className="button_container">
                            {
                                (productDetail['usePunchoutDialog']) && (productDetail['popBtn']) && (
                                    <div className="punchout_cta_container">
                                        <IoButton classOverride="product-primary-btn punchout-btn" buttonText={productDetail['popBtn']} onClick={() => punchOutToLink(productDetail['completePunchOutUrl'], productDetail['popBtn'])} />
                                    </div>
                                )
                            }
                            {
                                (productDetail['usePunchoutDialog']) && (productDetail['popExtraUrlBtn']) && (
                                    <div className="punchout_cta_container">
                                        <IoButton classOverride="product-primary-btn punchout-extra-btn" buttonText={productDetail['popExtraUrlBtn']} onClick={() => punchOutToLink(productDetail['punchoutAdditionalURL'], productDetail['popExtraUrlBtn'])} />
                                    </div>
                                )
                            }
                            {
                                (productDetail['usePunchoutDialog']) && (productDetail['popContUrlBtn']) && (
                                    <div className="punchout_cta_container">
                                        <IoButton classOverride="product-primary-btn punchout-cont-btn" buttonText={productDetail['popContUrlBtn']} onClick={() => punchOutToLink(productDetail['punchoutContUrl'], productDetail['popContUrlBtn'])} />
                                    </div>
                                )
                            }
                        </div>
                        <div className="link_back_container">
                            <a href='javascript:;' onClick={onPunchoutDialogClose}> &#8592; {namedstrings['goBackToPrev']} </a>
                        </div>
                    </div>
                </Dialog>)
            }

        </div>  
    )
}


function resizePageMobile() {
    if (window.innerWidth <= 768) {
        const Frame = frameComponentsMap['benefitproductsmobilemenu'];
        const frameEl   = document.getElementById('benefit-mobile');
        ReactDOM.render(
            <Frame frameInfo={frameData} />,
            frameEl
        );

        window.removeEventListener('resize', resizePageMobile);
    }
}

export default BenefitsFrame;
